import { Box, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { useTranslation } from 'react-i18next';
import useOpenable from '../../hooks/useOpenable';
import { ProductFragment } from '../products';
import suggestionIcon from '../../assets/images/naming-wizard-suggestion.png';
import ProductNameOptimizationDialog from './ProductNameOptimizationDialog';

interface ProductNameOptimizationCardProps {
  product: ProductFragment;
  onApply?: (name: string) => void;
}

export default function ProductNameOptimizationCard({ product, onApply }: ProductNameOptimizationCardProps): React.JSX.Element {
  const { t } = useTranslation(['products']);
  const { open, close, isOpen } = useOpenable();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 2,
        border: '1px solid',
        borderColor: 'outlineVariant.main',
        borderRadius: 3,
        backgroundColor: 'surfaceContainerLowest.main',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box component="img" src={suggestionIcon} alt="" sx={{ width: 32, height: 32 }} />
        <Typography variant="titleMedium" color="onPrimaryContainer">
          {t('products:name_optimization.card_title')}
        </Typography>
      </Box>
      <Typography variant="bodySmall" color="onPrimaryContainer">
        {t('products:name_optimization.card_description')}
      </Typography>
      <Button variant="tonal" startIcon={<AutoAwesomeOutlinedIcon />} onClick={open} sx={{ height: 40, minHeight: 40, alignSelf: 'flex-start' }}>
        {t('products:name_optimization.card_action')}
      </Button>
      {isOpen && <ProductNameOptimizationDialog product={product} onApply={onApply} onClose={close} />}
    </Box>
  );
}
